import { Features } from '../components';

export default (props) => {
    return (
        <div>
            <Features.Header />
            <Features.MainSection />
        </div>
    )
}